export class TrainingItem {    
trainingItemNumber:any;
trainingItemType!:number;
scheduled!:boolean;
}
